
import bhome from "../ProjectsSnaps/Bewaakoof/bhome.png"
import bmens from "../ProjectsSnaps/Bewaakoof/bmens.png"
import bwomens from "../ProjectsSnaps/Bewaakoof/bwomens.png"
import signup from "../ProjectsSnaps/Bewaakoof/signup.png"





import HomeSn from "../ProjectsSnaps/Crackdeal/HomeSn.png"
import womens from "../ProjectsSnaps/Crackdeal/womens.png"
import Admin from "../ProjectsSnaps/Crackdeal/Admin.png"
import checkout from "../ProjectsSnaps/Crackdeal/checkout.png"



import applehome from "../ProjectsSnaps/BlueApple/applehome.png"
import applestore from "../ProjectsSnaps/BlueApple/applestore.png"
import appleadmin from "../ProjectsSnaps/BlueApple/appleadmin.png"
import appledashboard from "../ProjectsSnaps/BlueApple/appledashboard.png"

import amzHome from "../ProjectsSnaps/AmazonClone/amzHome.png"
import amzProduct from "../ProjectsSnaps/AmazonClone/amzProduct.png"
import amzCheck from "../ProjectsSnaps/AmazonClone/amzCheck.png"
import amzCart from "../ProjectsSnaps/AmazonClone/amzCart.png"




const projectsData=[
    {
        title:"Crack-Deal",
        description:"CrackDeal (E-commerce platform) is an React.js application,  Designed to provide customers with a personalized easy-to-utilize user experience for purchasing products online.",
        techStack:["ReactJs", "Redux","React-Redux","HTML","JavaScript",'CSS','Chakra UI'],
        deployedURL:"https://subsequent-parcel-2806-mehulktik-gmailcom.vercel.app/",
        githubURL:"https://github.com/Mehul-Kanjariya/subsequent-parcel-2806",
        images:[HomeSn,womens,Admin,checkout],
        classTitle:"project-title",
        classDes:"project-description",
        classProj:"project-tech-stack",
        classGit:"project-github-link",
        classDep:"project-deployed-link"
    },
    {
        title:"Bewakoof Clone",
        description:"It is e-commerce website , popularly known for clothing items. Designed to provide customers with a personalized easy-to-utilize user experience for purchasing products online.",
        techStack:["ReactJs","HTML",'CSS',"JavaScript"],
         deployedURL:"https://bewakoof-clone-alok6103.vercel.app/",
         githubURL:"https://github.com/ALOK6103/wakeful-rabbits-8403/tree/main/my-app",
        images:[bhome,bwomens,bmens,signup],
        classTitle:"project-title",
        classDes:"project-description",
        classProj:"project-tech-stack",
        classGit:"project-github-link",
        classDep:"project-deployed-link"
    },
    {
        title:"Blue-Apple",
        description: "Apple Inc. (formerly Apple Computer Inc.) is an American computer and consumer electronics company famous for creating the iPhone, iPad and Macintosh computers.",
        techStack:["React", "HTML",'CSS',"JavaScript"],
         deployedURL:"https://blueapple.vercel.app/",
         githubURL:"https://github.com/ALOK6103/Blue-Apple",
        images:[applehome,appleadmin,applestore,appledashboard],
        classTitle:"project-title",
        classDes:"project-description",
        classProj:"project-tech-stack",
        classGit:"project-github-link",
        classDep:"project-deployed-link"
    },
    {
        title:"Amazon Clone",
        description: "This is the clone of Amazon website, world's largest e-commerce website which deals with the sales of various products like clothing products, electronics etc.",
        techStack:["React","React-redux","NodeJs", "MongoDB","Mongoose", "HTML",'CSS',"JavaScript"],
        deployedURL:"https://shopping-quest.vercel.app/",
        githubURL:"https://github.com/fahad9988/mammoth-zoo-7517",
        images:[amzHome,amzCart,amzProduct,amzCheck],
        classTitle:"project-title",
        classDes:"project-description",
        classProj:"project-tech-stack",
        classGit:"project-github-link",
        classDep:"project-deployed-link"
    }
]

export default projectsData;